// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_ut-0";
export var checkoutRateBadgeLink = "_ut-1";